import { render, staticRenderFns } from "./moreDonateList.vue?vue&type=template&id=0c959436&scoped=true&"
import script from "./moreDonateList.vue?vue&type=script&lang=js&"
export * from "./moreDonateList.vue?vue&type=script&lang=js&"
import style0 from "./moreDonateList.vue?vue&type=style&index=0&id=0c959436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c959436",
  null
  
)

export default component.exports